import { Account } from "../../types/influencer/influencerTypes";
import { formatNumber } from "../../utils/helpers";

const SocialAccountStats: React.FC<{ mediaCount: number, followersCount: number, followsCount: number, engagementScore: number | null, engagementRate: number | null, engagementRateDetails: { name: string, color: string } | null }> = ({ mediaCount, followersCount, followsCount, engagementScore, engagementRate, engagementRateDetails}) => {
    return (
        <div className="card rounded-4 shadow-none border-0 mb-0">
            <div className="card-body d-flex flex-wrap justify-content-evenly flex-row rounded-4 px-0 py-2">
                <div className="d-flex w-100 py-2 text-center">
                    <div className="m-auto">
                        <strong className="color-theme d-block font-14 mb-n1">{formatNumber(mediaCount ?? 0)}</strong>
                        <span className="color-theme d-block mt-n2 font-10 opacity-50">Posts</span>
                    </div>
                    <div className="m-auto">
                        <strong className="color-theme d-block font-14 mb-n1">{formatNumber(followersCount ?? 0)}</strong>
                        <span className="color-theme d-block mt-n2 font-10 opacity-50">Followers</span>
                    </div>
                    <div className="m-auto">
                        <strong className="color-theme d-block font-14 mb-n1">{formatNumber(followsCount ?? 0)}</strong>
                        <span className="color-theme d-block mt-n2 font-10 opacity-50">Following</span>
                    </div>
                    <div className="m-auto">
                        <strong className="color-theme d-block font-14 mb-n1 d-flex justify-content-center align-item">{engagementScore ?? "-"}</strong>
                        <span className="color-theme d-block mt-n2 font-10 opacity-50">Engagement Score</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SocialAccountStats;